import { Delete, Get, Post, Put, setFixHeader } from "../utils/request";

export class AgentService{
    static async  listAll(){
        let result = await Get("/agents");

        return result.data;
    } 

    static async Delete(id :number){
        return await Delete(`/agents/${id}`)
    }

    static async Add(agent:any){
        await Post(`/agents`,{},agent)
    }

    
    static async Update(id:number,name:string){
        await Put(`/agents`,{},{id,name})
    }

}
